<template>
  <div>
    <breadcrumb></breadcrumb>
    <con-title>关于我们</con-title>
    <div class="con w">
      <div class="about">
        <div class="about-img">
          <img src="https://ossimage.xiaochejun.cn/images/web/pic_16224395770172615.jpg" alt="" />
        </div>
        <div class="about-con">
          南京知车君网络科技有限公司，成立于2016年底，创始人深耕二手车市场信息化升级改造十余载为二车市场实现品牌化运营、让车商好卖车、好收车、让消费者敢买。助力二手车市场升级转化新模式，管理标准统一、线上线下融合、二手车市场互联互通，最终完成新型智慧化二手车交易市场。
        </div>
      </div>
      <div class="ts">
        智慧二手车市场：通过大数据+互联网为基础，推动以人（消费者）为中心的商业重构，让消费者在合适时间买到合适的产品，让市场管理智能化，客户管理智慧化，真正赋能场内车商，促进加速商品流转。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.about {
  display: flex;
  padding-bottom: 30px;
  .about-img {
    width: 38%;
    height: 260px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .about-con {
    width: 62%;
    line-height: 2;
    font-size: 14px;
    color: #555;
    text-indent: 2em;
    padding-left: 20px;
  }
}
.ts {
  background: #f1f1f1;
  padding: 20px 15px;
  margin-bottom: 25px;
}
</style>
